<form class="w-full max-w-lg">
  <div class="flex flex-wrap mb-3">
    <div class="w-full">
      <label class="block uppercase tracking-wide text-sm mb-2 font-medium" for="grid-first-name">
        Username
      </label>
      <input class="appearance-none block w-full bg-gray-100 border border-gray-300 rounded py-3 px-4 mb-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-username" type="text" placeholder="user-12345">
    </div>
  </div>
  <div class="flex flex-wrap mb-3">
    <div class="w-full">
      <label class="block uppercase tracking-wide text-sm mb-2 font-medium" for="grid-password">
        Name
      </label>
      <input class="appearance-none block w-full bg-gray-100 border border-gray-300 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password" type="text" placeholder="John/Mary">
    </div>
  </div>
</form>